module.exports = __webpack_public_path__ + "img/logo-inverted.376b3481.png";